import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}


export const isIframe = typeof window !== 'undefined' && window.self !== window.top;

// ── slug helpers ────────────────────────────────────────────────────────
//
// slugify: URL-safe lowercased dash-joined string. Strips HTML, collapses
//   whitespace and non-alphanumerics. Optional `max` truncates the result.
// randomSuffix: short alphanumeric tail to disambiguate non-unique titles
//   (e.g. two posts called "First Drive" → first-drive-x4k7 / first-drive-q9z1).
// newPostSlug: combines the two — used when CREATING a club_post row.
// clubPostUrlSlug: returns the URL slug for an existing post. Prefers the
//   persisted `post.slug` column; falls back to generating one from post
//   fields for any legacy row that somehow has no slug.
// ensureClubSuffix: appends " Club" to a name that doesn't already end with
//   it (case-insensitive). "BMW" → "BMW Club"; "Country Club" → unchanged.

const STRIP_HTML = /<[^>]*>/g;

export function slugify(input, { max = 60 } = {}) {
  if (!input) return '';
  return String(input)
    .replace(STRIP_HTML, ' ')
    .toLowerCase()
    .trim()
    .slice(0, max)
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function randomSuffix(len = 5) {
  return Math.random().toString(36).slice(2, 2 + len);
}

export function newPostSlug(title, { fallback = 'post', length = 50 } = {}) {
  const base = slugify(title, { max: length }) || fallback;
  return `${base}-${randomSuffix(5)}`;
}

export function clubPostUrlSlug(post) {
  if (!post) return '';
  if (post.slug) return post.slug;
  // Legacy fallback — pre-migration rows without a slug column. Use a short
  // id prefix instead of the full UUID so URLs stay compact.
  const title = slugify(post.content || post.poll_question || post.event_title || '', { max: 50 });
  const idTail = (post.id || '').replace(/-/g, '').slice(0, 8) || 'post';
  return title ? `${title}-${idTail}` : `post-${idTail}`;
}

export function ensureClubSuffix(name) {
  if (!name) return name;
  const trimmed = String(name).trim();
  if (!trimmed) return trimmed;
  // Already ends with "Club" (any case) — leave it alone.
  if (/\bclub\s*$/i.test(trimmed)) return trimmed;
  return `${trimmed} Club`;
}

// ensureShopSuffix: appends " Shop" to a name that doesn't already end with
//   it (case-insensitive). "OCTNE" → "OCTNE Shop"; "JDM Shop" → unchanged.
//   Same pattern as ensureClubSuffix.
export function ensureShopSuffix(name) {
  if (!name) return name;
  const trimmed = String(name).trim();
  if (!trimmed) return trimmed;
  if (/\bshop\s*$/i.test(trimmed)) return trimmed;
  return `${trimmed} Shop`;
}
